// utils/apiThunk.js
import {logout, refreshToken} from "../actions";
import {reposWebApi} from "../actions/customerAPI";
import secureLocalStorage from "react-secure-storage";

// Each URL gets its own AbortController so cancelling one request
// never affects a simultaneously in-flight request to a different URL.
const controllerMap = {};

export const apiCall = ({
                            url,
                            params = {},
                            method = "get",
                            data = null,
                            successType,
                            failType,
                            loadingType,
                            fetchMoreData = false,
                            callback = null,
                            requestId = null,
                            logosType,
                            requestMeta,
                            requestKey,
                            signal: externalSignal,
                            validateMeta = false,
                            authRetryCount = 0,
                        }) => {
    // Abort only the previous request for THIS specific URL, not all requests
    const key = requestKey || url;
    if (!externalSignal && controllerMap[key]) controllerMap[key].abort();
    if (!externalSignal) controllerMap[key] = new AbortController();
    const signal = externalSignal || controllerMap[key].signal;
    const meta = requestMeta || requestId != null
        ? {...requestMeta, ...(requestId != null ? {requestId} : {})}
        : undefined;

    return async (dispatch) => {
        if (loadingType && !fetchMoreData) {
            dispatch({type: loadingType, payload: false, meta});
        }

        try {
            const response = await reposWebApi({
                method,
                url,
                params,
                data,
                signal,
                headers: {
                    Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
                },
            });

            if (validateMeta && response?.data?.meta?.is_error) {
                throw new Error(response.data.meta.message || "The request failed.");
            }
            const responseData = response?.data?.data;

            dispatch({
                type: successType,
                payload: responseData,
                fetchMoreData: fetchMoreData,
                meta,
            });

            response?.data?.logo && dispatch({
                type: logosType,
                payload: responseData,
                fetchMoreData: fetchMoreData,
            });

            if (callback) {
                if (response?.data?.logo) {
                    callback({...response?.data});
                } else callback(responseData?.results || responseData);
            }

            return responseData;

        } catch (error) {

            const isCanceledRequest =
                error?.code === "ERR_CANCELED" ||
                error?.name === "CanceledError" ||
                error?.name === "AbortError" ||
                error?.message === "canceled" ||
                (signal?.aborted && error?.message === "Network Error");

            if (isCanceledRequest) {
                return;
            }

            const normalizedError = {
                status: error?.response?.status,
                message:
                    error?.response?.data?.message ||
                    error?.response?.data?.meta?.message ||
                    (typeof error?.response?.data?.data?.error === "string" && error.response.data.data.error) ||
                    (typeof error?.response?.data?.data === "string" && error.response.data.data) ||
                    error?.response?.data?.error ||
                    error?.message ||
                    'Something went wrong',
                data: error?.response?.data,
                url,
                method,
            };

            if (error?.response?.status === 401 && (!validateMeta || authRetryCount === 0)) {
                try {
                    await dispatch(refreshToken());
                    return dispatch(
                        apiCall({
                            url,
                            params,
                            method,
                            data,
                            successType,
                            failType,
                            loadingType,
                            fetchMoreData,
                            callback,
                            requestId,
                            logosType,
                            requestMeta, requestKey, signal: externalSignal, validateMeta,
                            authRetryCount: authRetryCount + 1,
                        })
                    );
                } catch (err) {
                    dispatch(logout());
                    if (failType) {
                        dispatch({type: failType, payload: normalizedError, meta});
                    }
                    return normalizedError;
                }
            } else {
                if (failType) {
                    dispatch({type: failType, payload: normalizedError, meta});
                }
                return normalizedError;
            }
        }
    };
};
